/* ============================================================
   BORASOL — global.js  ·  cart drawer (AJAX), menu, accordion
   Vanilla, geen libraries.
   ============================================================ */
(function () {
  'use strict';

  const money = (cents) => {
    const v = (cents / 100).toFixed(2).replace('.', ',');
    return '€' + v;
  };

  /* ---------- Drawer / scrim helpers ---------- */
  function openEl(el) { if (el) { el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; } }
  function closeEl(el) { if (el) { el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; } }

  /* ---------- Cart ---------- */
  const CartDrawer = {
    el: null,
    init() {
      this.el = document.getElementById('CartDrawer');
      document.addEventListener('click', (e) => {
        const open = e.target.closest('[data-cart-open]');
        if (open) { e.preventDefault(); openEl(this.el); }
        if (e.target.closest('[data-cart-close]')) { closeEl(this.el); }
      });
      document.addEventListener('keyup', (e) => { if (e.key === 'Escape') closeEl(this.el); });

      // AJAX add-to-cart
      document.addEventListener('submit', (e) => {
        const form = e.target.closest('form[action$="/cart/add"], form[action*="/cart/add"]');
        if (!form) return;
        e.preventDefault();
        this.add(form);
      });

      // qty + remove inside drawer
      document.addEventListener('click', (e) => {
        const change = e.target.closest('[data-line-change]');
        if (change) { e.preventDefault(); this.change(change.dataset.line, change.dataset.lineChange); }
        const remove = e.target.closest('[data-line-remove]');
        if (remove) { e.preventDefault(); this.change(remove.dataset.lineRemove, 0); }
      });
    },
    async add(form) {
      const btn = form.querySelector('[type="submit"]');
      if (btn) { btn.setAttribute('disabled', ''); btn.dataset.txt = btn.textContent; btn.textContent = '…'; }
      try {
        const fd = new FormData(form);
        const res = await fetch(window.routes.cart_add_url + '.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' }, body: fd });
        if (!res.ok) throw new Error('add failed');
        await this.refresh();
        openEl(this.el);
      } catch (err) { console.error(err); }
      finally { if (btn) { btn.removeAttribute('disabled'); btn.textContent = btn.dataset.txt || 'In winkelwagen'; } }
    },
    async change(line, qty) {
      const res = await fetch(window.routes.cart_change_url + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ line: Number(line), quantity: Number(qty) })
      });
      if (res.ok) await this.refresh();
    },
    async refresh() {
      // Re-render the drawer via the Section Rendering API
      const res = await fetch(`${window.location.pathname}?section_id=cart-drawer`);
      if (!res.ok) return;
      const text = await res.text();
      const html = new DOMParser().parseFromString(text, 'text/html');
      const fresh = html.querySelector('#CartDrawer');
      const cur = document.getElementById('CartDrawer');
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      this.updateBubble();
    },
    async updateBubble() {
      const res = await fetch(window.routes.cart_url + '.js');
      if (!res.ok) return;
      const cart = await res.json();
      document.querySelectorAll('[data-cart-count]').forEach((n) => {
        n.textContent = cart.item_count;
        n.hidden = cart.item_count === 0;
      });
    }
  };

  /* ---------- Header: mega menu + mobile menu ---------- */
  const Nav = {
    init() {
      document.addEventListener('click', (e) => {
        const shop = e.target.closest('[data-mega-toggle]');
        if (shop) {
          e.preventDefault();
          const panel = document.getElementById(shop.getAttribute('aria-controls'));
          const open = shop.getAttribute('aria-expanded') === 'true';
          shop.setAttribute('aria-expanded', String(!open));
          if (panel) panel.hidden = open;
        } else if (!e.target.closest('[data-mega-panel]')) {
          document.querySelectorAll('[data-mega-toggle][aria-expanded="true"]').forEach((t) => {
            t.setAttribute('aria-expanded', 'false');
            const p = document.getElementById(t.getAttribute('aria-controls'));
            if (p) p.hidden = true;
          });
        }
        if (e.target.closest('[data-menu-open]')) { openEl(document.getElementById('MobileMenu')); }
        if (e.target.closest('[data-menu-close]')) { closeEl(document.getElementById('MobileMenu')); }
        if (e.target.closest('[data-search-open]')) { openEl(document.getElementById('SearchOverlay')); }
        if (e.target.closest('[data-search-close]')) { closeEl(document.getElementById('SearchOverlay')); }
      });
    }
  };

  /* ---------- Accordion ---------- */
  function Accordion() {
    document.addEventListener('click', (e) => {
      const t = e.target.closest('[data-accordion-trigger]');
      if (!t) return;
      const item = t.closest('[data-accordion]');
      if (item) item.toggleAttribute('open');
    });
  }

  /* ---------- Predictive search ---------- */
  const Search = {
    init() {
      const input = document.querySelector('[data-predictive-input]');
      const results = document.querySelector('[data-predictive-results]');
      if (!input || !results) return;
      let t;
      input.addEventListener('input', () => {
        clearTimeout(t);
        const q = input.value.trim();
        if (q.length < 2) { results.innerHTML = ''; return; }
        t = setTimeout(async () => {
          const url = `${window.routes.predictive_search_url}?q=${encodeURIComponent(q)}&section_id=predictive-search`;
          const res = await fetch(url);
          if (res.ok) results.innerHTML = await res.text();
        }, 220);
      });
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    CartDrawer.init();
    Nav.init();
    Accordion();
    Search.init();
  });

  window.Borasol = { CartDrawer, money };
})();
